import React from "react";
import Message from "./Message";

/**
 * Class to display a live agent chat message.
 *
 * This class relies on an additional payload property set from chat-bot.jsx
 * which determines if it is a live agent chat. This allows the chat message
 * window to display the live agent's name over the bot name.
 */
export default class LiveAgentMessage extends Message {
    render() {
        return (
            <div className={this.generateSenderClassName('live-agent')}>
                {this.generateSenderMessage(this.props.payload.agent_name)}
                <div className='live-agent__text message-text' dangerouslySetInnerHTML = {this.evaluateMarkdown(this.props.payload.text)}>
                </div>
            </div>
        );
    }
}